export class LoginFormModel {
    constructor(
        public usuario: string = '',
        public senha: string = ''
    ){}
}